module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.error[0]
    }
  }, [_c('label', [_vm._v("Тип операции")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Выберите тип операции",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.localValue),
      callback: function($$v) {
        _vm.localValue = $$v
      },
      expression: "localValue"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "D",
      "label": "+ Пополнение"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "C",
      "label": "- Снятие"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error[0]))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4f5d2d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/transaction/fields/TransactionType.vue
// module id = 721
// module chunks = 0